import manifest from "./image-dimensions.json";

type Dimensions = { width: number; height: number };

const dimensions = manifest as Record<string, Dimensions>;

export function getImageDimensions(src: string): Dimensions {
  return dimensions[src] ?? { width: 1600, height: 900 };
}
